<template>
  <div class="runTask">
    <div class="task-info">
      <div>获取签名{{ getSignatureTimes }}次，心跳检测{{ heartbeatTimes }}次。</div>
      <div>已查询{{ getNewTaskTimes }}次，本次查询到{{ tasks.length }}条任务。</div>
      <div>正在执行：{{ tasks.length == 0 ? '无' : `[${tasks[0].type}]` + tasks[0].name }}</div>
      <div v-if="entry == 'single_chat_tools'">当前客户userId：</div>
      <div v-if="entry == 'single_chat_tools'">{{ userId }}</div>
      <div v-if="entry == 'group_chat_tools'">当前群聊chatId：</div>
      <div v-if="entry == 'group_chat_tools'">{{ chatId }}</div>
      <div v-else>从“{{ entry }}”进入应用，不查询任务</div>
      <div class="task-buttons">
        <el-button icon="el-icon-s-order" @click="logShow = !logShow" size="mini">
          {{ logShow ? '关闭日志' : '查看日志' }}
        </el-button>
      </div>
      <!-- <div class="task-buttons">
        <el-button @click="removeStorage" size="mini">清空缓存</el-button>
        <el-button @click="intervalClear" >
          {{ getNewTaskTimer ? '停止查询任务' : '已停止查询任务' }}
        </el-button>
      </div> -->
    </div>
    <div v-if="!logShow" class="task-content">
      <img
        v-if="tasks.length == 0"
        src="../../assets/query.jpg"
        style="width: 200px; height: 200px"
      />
      <img v-else src="../../assets/run.jpg" style="width: 200px; height: 200px" />
      <span v-if="tasks.length == 0" class="c-m-t-10">暂无任务</span>
      <span v-else class="c-m-t-10">任务执行中，请勿退出！</span>
    </div>
    <div v-if="logShow" class="task-logs">
      <div v-for="(item, i) in logs" :key="i" class="task-log">
        <div class="log-time">{{ item.time }}</div>
        <div class="log-content">
          <span :class="item.type == 'error' ? 'c_red log-type' : 'c_blue log-type'">
            [{{ item.type }}]
          </span>
          <span>{{ item.content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    return {
      tenantId: '1340835581184723420',
      corpid: 'wwb580bbf2548e6123', // 企业ID
      agentid: '1000006', // 应用ID
      url: encodeURIComponent(window.location.href), // 应用当前网页的URL， 不包含#及其后面部分
      scope: 'snsapi_privateinfo', // snsapi_base 静默授权、snsapi_privateinfo 手动授权
      token: {}, // 企业注入和应用注入的 timestamp、nonceStr、signature
      entry: '', // 用户是从哪个入口打开页面 single_chat_tools:从单聊会话的工具栏进入、group_chat_tools:从群聊会话的工具栏进入
      baseChatIds: [], // 应用所有基础群id，移动端管家只在基础群工作台查询建群任务。
      userId: '', // 当前客户userId
      chatId: '', // 当前群聊chatId
      userAgent: '', // 应用客户端操作系统，android ios mac windows
      wxwork: '', // 应用是否在企业微信中打开
      getSignatureTimes: 0, // 获取签名次数
      heartbeatTimer: null, // 心跳检测定时器
      heartbeatTimes: 0, // 心跳检测次数
      getNewTaskTimer: null, // 查询待办任务定时器
      getNewTaskTimes: 0, // 查询待办任务的次数，每次加载应用网页后开始从0计数。
      tasks: [], // 待办任务列表
      logShow: false, // 是否展示运行日志
      logs: [] // 运行日志
    };
  },
  mounted() {
    this.logs.push({ time: new Date().toLocaleTimeString(), type: 'info', content: '开始调试' });
    // 打开会话或手动切换群聊，都会触发页面重新加载mounted()；
    // 展开/收起右侧工具栏：mac会触发重新加载；windows不会触发重新加载，且收起后仍在运行。
    // 右侧工具页签切换不会触发重新加载，且切换到非应用页面，应用仍在运行。
    // 企微最小化后，或者屏幕锁定但不睡眠，应用仍在运行。
    window.$this = this;

    //  获取网页授权后返回的code，调用后台接口登录
    let params = this.osg.paramObj();
    if (params && params.code) {
      this.logs.push({
        time: new Date().toLocaleTimeString(),
        type: 'info',
        content: '进入1.网页授权后携带code进入'
      });
      // 授权重定向到当前页面
      this.qwOAuth(params.code, res => {
        localStorage['userInfo'] = JSON.stringify(res.data);
        // 每隔30分钟获取一次token是否有变化（wx.config、wx.agentConfig 注入接口，一小时内，每个应用不能超过100次）
        this.getSignature();
        setInterval(() => {
          this.getSignature();
        }, 30 * 60 * 1000);
        // 获取基础群id
        this.getAgent();
        // 每隔5分钟 心跳检测
        this.heartbeatTimer = setInterval(() => {
          this.heartbeat();
        }, 5 * 60 * 1000);
      });
    } else if (!localStorage['userInfo']) {
      this.logs.push({
        time: new Date().toLocaleTimeString(),
        type: 'info',
        content: '进入2.没有登陆信息，接下来跳转授权页面。'
      });
      // 没有登录信息
      this.toAuth();
      return;
    } else {
      this.logs.push({
        time: new Date().toLocaleTimeString(),
        type: 'info',
        content: '进入3.有登陆信息，接下来获取签名'
      });
      // 有登录信息，继续运行。
      // 如果登录信息已超时，后天接口返回登录失效，前端触发去网页授权。
      // 每隔30分钟获取一次token是否有变化（wx.config、wx.agentConfig 注入接口，一小时内，每个应用不能超过100次）
      this.getSignature();
      setInterval(() => {
        this.getSignature();
      }, 30 * 60 * 1000);
      // 获取基础群id
      this.getAgent();
      // 每隔5分钟 心跳检测
      this.heartbeatTimer = setInterval(() => {
        this.heartbeat();
      }, 5 * 60 * 1000);
    }

    // 获取应用客户端系统，mac不支持拉人进群
    let userAgent = navigator.userAgent.toLowerCase();
    if (/(Android)/i.test(userAgent)) {
      this.userAgent = 'android';
    } else if (/(iPhone|iPad|iPod|iOS)/i.test(userAgent)) {
      this.userAgent = 'ios';
    } else if (/macintosh|mac os x/i.test(userAgent)) {
      this.userAgent = 'mac';
    } else if (
      userAgent.indexOf('win32') != -1 ||
      userAgent.indexOf('wow32') != -1 ||
      userAgent.indexOf('win64') != -1 ||
      userAgent.indexOf('wow64') != -1
    ) {
      this.userAgent = 'windows';
    }

    // 判断应用是否在企业微信中打开
    this.wxwork = /wxwork/i.test(navigator.userAgent);
  },
  methods: {
    // 获取应用所有基础群id，移动端管家只在基础群工作台查询建群任务。
    getAgent() {
      this.osg.ajax(
        'wm/biz/qw/getEWechatApplication',
        { corpid: this.corpid, agentId: this.agentid },
        res => {
          this.baseChatIds = res.data.exts.baseChatIds || [];
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'success',
            content: 'getAgent：baseChatIds:' + this.baseChatIds
          });
        },
        {
          fail: res => {
            this.logs.push({
              time: new Date().toLocaleTimeString(),
              type: 'error',
              content: ' getAgent：' + res
            });
          }
        }
      );
    },
    // 打开网页授权
    toAuth() {
      // redirect_uri不能直接去location.href，会导致重复拼多个code和state。
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
        this.corpid
      }&redirect_uri=${encodeURIComponent(
        window.location.origin + window.location.pathname
      )}&response_type=code&scope=${this.scope}&agentid=${this.agentid}#wechat_redirect`;
    },
    // 网页授权登录
    qwOAuth(code, callback) {
      this.logs.push({
        time: new Date().toLocaleTimeString(),
        type: 'info',
        content:
          'qwOAuth params：code:' +
          code +
          '; state:' +
          this.tenantId +
          ',' +
          this.corpid +
          ',' +
          this.agentid
      });
      this.osg.ajax(
        'wm/index/qwOAuth',
        {
          code,
          state: this.tenantId + ',' + this.corpid + ',' + this.agentid
        },
        res => {
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'success',
            content: 'qwOAuth'
          });
          if (callback) callback(res);
        },
        {
          noload: true,
          fail: res => {
            this.logs.push({
              time: new Date().toLocaleTimeString(),
              type: 'error',
              content: 'qwOAuth：' + res
            });
            window.alert(res.message || '网页授权登录失败，请重新授权登录！');
            this.toAuth();
          }
        }
      );
    },
    // 获取签名
    getSignature() {
      this.osg.ajax(
        'wm/biz/qw/getSignature',
        {
          corpid: this.corpid,
          agentId: this.agentid,
          url: this.url
        },
        res => {
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'success',
            content: 'getSignature'
          });
          this.token = res.data;
          this.getSignatureTimes++;
          this.config();
        },
        {
          noload: true,
          fail: res => {
            this.logs.push({
              time: new Date().toLocaleTimeString(),
              type: 'error',
              content: 'getSignature：' + res
            });
            // 登录信息已过期，重新发起企微授权登录
            this.toAuth();
          }
        }
      );
    },
    // 仅心跳检测 5分钟/次 更新token，但不注入企业和应用 因为每个应用每小时不能超过100次。
    heartbeat() {
      this.osg.ajax(
        'wm/biz/qw/heartbeat',
        {
          corpid: this.corpid,
          agentId: this.agentid,
          url: this.url
        },
        res => {
          this.token = res.data;
          this.heartbeatTimes++;
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'success',
            content: 'heartbeat'
          });
        },
        {
          noload: true,
          fail: res => {
            this.logs.push({
              time: new Date().toLocaleTimeString(),
              type: 'error',
              content: 'heartbeat：' + res
            });
            // 登录信息已过期，重新发起企微授权登录
            this.toAuth();
          }
        }
      );
    },
    // 注入权限验证配置
    config() {
      wx.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: this.corpid, // 必填，企业微信的corpID，必须是本企业的corpID，不允许跨企业使用
        timestamp: this.token.corp.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.token.corp.nonce, // 必填，生成签名的随机串
        signature: this.token.corp.sign, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: [
          'getContext',
          'getCurExternalContact',
          'getCurExternalChat',
          'openEnterpriseChat',
          'updateEnterpriseChat',
          'sendChatMessage'
        ] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      });
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      wx.ready(() => {
        this.logs.push({
          time: new Date().toLocaleTimeString(),
          type: 'success',
          content: 'wx.config'
        });
        this.agentConfig();
      });
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      wx.error(res => {
        // clearInterval(this.heartbeatTimer);
        this.logs.push({
          time: new Date().toLocaleTimeString(),
          type: 'error',
          content: 'wx.config：' + JSON.stringify(res)
        });
        // 当ticket过期时，6分钟后重新获取签名并注入权限。
        setTimeout(() => {
          this.getSignature();
        }, 6 * 60 * 1000);
      });
    },
    // 注入应用权限
    agentConfig() {
      wx.agentConfig({
        corpid: this.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: this.agentid, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp: this.token.agent.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.token.agent.nonce, // 必填，生成签名的随机串
        signature: this.token.agent.sign, // 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: [
          'getContext',
          'getCurExternalContact',
          'getCurExternalChat',
          'openEnterpriseChat',
          'updateEnterpriseChat',
          'sendChatMessage'
        ], //必填，传入需要使用的接口名称
        success: () => {
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'success',
            content: 'wx.agentConfig'
          });
          // 获取进入H5页面的入口环境
          this.getContext();
        },
        fail: res => {
          // clearInterval(this.heartbeatTimer);
          if (res.errMsg.indexOf('function not exist') > -1) {
            this.logs.push({
              time: new Date().toLocaleTimeString(),
              type: 'error',
              content: 'wx.agentConfig：版本过低请升级'
            });
          } else {
            this.logs.push({
              time: new Date().toLocaleTimeString(),
              type: 'error',
              content: 'wx.agentConfig：' + JSON.stringify(res)
            });
          }
          // 当ticket过期时，6分钟后重新获取签名并注入权限。
          setTimeout(() => {
            this.getSignature();
          }, 6 * 60 * 1000);
        }
      });
    },
    // 获取进入H5页面的入口环境
    getContext() {
      wx.invoke('getContext', {}, res => {
        if (res.err_msg == 'getContext:ok') {
          this.entry = res.entry; //返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment
          if (res.entry == 'single_chat_tools') {
            this.getCurExternalContact();
          } else if (res.entry == 'group_chat_tools') {
            this.getCurExternalChat();
          } else {
            this.logs.push({
              time: new Date().toLocaleTimeString(),
              type: 'error',
              content: 'getContext：请从“外部单聊工具栏”或“外部群聊工具栏”进入应用'
            });
          }
        } else {
          //错误处理
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'error',
            content: 'getContext：' + JSON.stringify(res)
          });
        }
      });
    },
    // 获取当前外部联系人userId
    getCurExternalContact() {
      wx.invoke('getCurExternalContact', {}, res => {
        if (res.err_msg == 'getCurExternalContact:ok') {
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'success',
            content: 'getCurExternalContact：userid:' + res.userId
          });
          this.userId = res.userId; //返回当前外部联系人userId
          // 每隔5秒查询1次待办任务，时间间隔不能太短，需预留等待查询返回后可能停止定时器的时间。
          this.getNewTask();
          clearInterval(this.getNewTaskTimer);
          this.getNewTaskTimer = setInterval(() => {
            this.getNewTask();
          }, 5000);
        } else {
          //错误处理
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'error',
            content: 'getCurExternalContact：' + JSON.stringify(res)
          });
        }
      });
    },
    // 获取当前外部群的群ID
    getCurExternalChat() {
      wx.invoke('getCurExternalChat', {}, res => {
        if (res.err_msg == 'getCurExternalChat:ok') {
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'success',
            content: 'getCurExternalChat：chatId:' + res.chatId
          });
          this.chatId = res.chatId; //返回当前外部群的群聊ID
          // 每隔5秒查询1次待办任务，时间间隔不能太短，需预留等待查询返回后可能停止定时器的时间。
          this.getNewTask();
          clearInterval(this.getNewTaskTimer);
          this.getNewTaskTimer = setInterval(() => {
            this.getNewTask();
          }, 5000);
        } else {
          //错误处理
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'error',
            content: 'getCurExternalChat：' + JSON.stringify(res)
          });
        }
      });
    },
    // 查询待办任务
    getNewTask() {
      // TODO:任务需要有数据权限，后台返回登录人的任务。
      let params = {};
      if (this.userAgent == 'mac') {
        params['neType'] = '1,2'; // mac端企微创建群聊没有回调、不支持拉人进群任务。
      } else if (this.userAgent == 'android' || this.userAgent == 'ios') {
        // 移动端只在基础群查询建群任务，其他群聊不查询任何任务。
        if (this.baseChatIds.indexOf(this.chatId) != -1) {
          params['type'] = '1';
        } else {
          clearInterval(this.getNewTaskTimer);
          return;
        }
      }
      // type: this.userAgent == 'windows' ? '1,2,3' : null // windows端企微只用来执行拉人进群任务；//TODO:windows暂时也模拟成员端执行建群任务
      this.osg.ajax(
        '/wm/biz/qwtask/newTask',
        params,
        res => {
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'success',
            content: 'getNewTask：查到' + res.data.length + '条任务'
          });
          this.getNewTaskTimes++;
          this.tasks = res.data;
          // 获取到新任务时，停止定时器，优先执行完第1条任务再启动定时查询，防止不停止定时器查询到的最新待办任务顺序变更导致执行错乱。
          if (res.data.length > 0) {
            clearInterval(this.getNewTaskTimer);
            // 执行第1条任务
            this.runTask(res.data[0]);
          }
        },
        {
          noload: true,
          fail: res => {
            this.logs.push({
              time: new Date().toLocaleTimeString(),
              type: 'error',
              content: 'getNewTask：' + JSON.stringify(res)
            });
          }
        }
      );
    },
    /**
     * 执行当前任务
     * private String name;
     * private String code;
     * private int type;//1为建群任务 2为拉人任务 3为消息任务
     * private String bizType;//绑定的业务类型 如:serviceAppointment
     * private String bizId;//绑定的业务数据
     * private String customize;//自定义标识 用于统计发送任务的位置或其他
     * private String qwUserIds;//企业微信参与会话的企业成员列表 多成员用;隔开  type=1需要有值
     * private String qwExternalUserIds;//企业微信参与会话的外部联系人列表 多人员用;隔开 type=1需要有值
     * private String groupName;//群名称 type=1需要有值
     * private String chatId;//群Id type=1必须为空串 type=2||3要处理任务的群Id
     * private String qwUserIdsToAdd;//新增的企业人员 type=2时要拉人处理必填
     * private String msgtype;//支持文本(“text”)，图片(“image”)，视频(“video”)，文件(“file”)，H5(“news”）和小程序(“miniprogram”)
     * private String content;//msgtype=text时消息内容 msgtype=image;video;file时素材id
     * private String appId;//小程序的appid，企业已关联的任一个小程序
     * private String link;//msgtype=news时 H5消息页面url 必填  msgtype=miniprogram时 小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面
     * private String title;//msgtype=news;miniprogram 消息标题
     * private String imgUrl;//msgtype=news;miniprogram 消息标题封面图
     * private String desc;//msgtype=news时 H5消息摘要
     * private int status;//任务状态 0发布 1执行成功 -1执行失败
     * private String failMemo;//status为-1时 存在执行失败原因
     */
    runTask(task) {
      if (task.type == 1) {
        // 建群
        this.openEnterpriseChat(task);
      } else if (task.type == 2) {
        // 拉人进群
        this.updateEnterpriseChat(task);
      } else if (task.type == 3) {
        // 发送消息
        if (this.chatId == task.chatId) {
          // 如果当前群聊是要发消息的群聊，则直接发送消息到当前群聊
          this.sendChatMessage(task);
        } else {
          // 否则先打开要发消息的群聊，然后在新加载的应用页面查询任务后会进入上面的if内。
          this.openEnterpriseChat(task);
        }
      } else {
        // 暂不支持的任务类型
        this.runTaskFail(task, '暂不支持的任务类型');
      }
    },
    // 执行任务成功，告知后台更新任务状态status=1，并重启查询待办任务定时器
    runTaskSuccess(task) {
      this.osg.ajax(
        '/wm/biz/qwtask/success',
        {
          id: task._id,
          chatId: task.chatId
        },
        () => {
          this.logs.push({
            time: new Date().toLocaleTimeString(),
            type: 'success',
            content: 'runTaskSuccess：'
          });
          // 每隔5秒查询1次待办任务，时间间隔不能太短，需预留等待查询返回后可能停止定时器的时间。
          // this.getNewTask(); // 不立即查询，预留RPA点发送的时间，防止多条消息都堆积在输入框。
          clearInterval(this.getNewTaskTimer);
          // 执行任务成功后一共延迟10秒查询新任务，给机器人发送消息留充足时间。
          setTimeout(() => {
            this.getNewTaskTimer = setInterval(() => {
              this.getNewTask();
            }, 5000);
          }, 5000);
        },
        {
          fail: res => {
            this.logs.push({
              time: new Date().toLocaleTimeString(),
              type: 'error',
              content: 'runTaskSuccess：' + JSON.stringify(res)
            });
          }
        }
      );
    },
    // 执行任务失败，告知后台更新任务状态status=-1，并重启查询待办任务定时器
    runTaskFail(task, msg) {
      this.osg.ajax('/wm/biz/qwtask/fail.do', { id: task._id, memo: msg }, () => {
        // 每隔5秒查询1次待办任务，时间间隔不能太短，需预留等待查询返回后可能停止定时器的时间。
        // this.getNewTask(); // 不立即查询，预留RPA点发送的时间，防止多条消息都堆积在输入框。
        clearInterval(this.getNewTaskTimer);
        this.getNewTaskTimer = setInterval(() => {
          this.getNewTask();
        }, 5000);
        this.logs.push({
          time: new Date().toLocaleTimeString(),
          type: 'error',
          content: 'runTaskFail：' + task.name + '执行失败，失败原因：' + msg
        });
      });
    },
    // 创建会话/打开已有会话
    openEnterpriseChat(task) {
      // 打开会话前缓存当前任务，避免success无法触发runTaskSuccess就已经跳转新页面。
      // 企微BUG：openEnterpriseChat接口mac端 创建群聊没有回调，打开已有群聊有回调。
      wx.openEnterpriseChat({
        // 注意：userIds和externalUserIds至少选填一个。内部群最多2000人；外部群最多500人；如果有微信联系人，最多40人
        userIds: task.qwUserIds, //参与会话的企业成员列表，格式为userid1;userid2;...，用分号隔开。
        externalUserIds: task.qwExternalUserIds, // 参与会话的外部联系人列表，格式为userId1;userId2;…，用分号隔开。
        groupName: task.groupName, // 会话名称。单聊时该参数传入空字符串""即可。
        chatId: task.chatId, // 若要打开已有会话，需指定此参数。如果是新建会话，chatId必须为空串
        success: res => {
          // 如果是发消息任务，且不是当前群聊，则此次调用是打开群聊，不需要成功回调runTaskSuccess
          // 下面发送请求之前不能有alert，否则自动进入新群聊后，原页面不确认alert无法继续发送请求。
          if (task.type == 3 && task.chatId != this.chatId) {
            return;
          }
          if (task.type == 1) {
            task.chatId = res.chatId; //返回当前群聊ID，仅当使用agentConfig注入该接口权限时才返回chatId
          }
          this.runTaskSuccess(task);
        },
        fail: res => {
          if (res.errMsg.indexOf('function not exist') > -1) {
            this.runTaskFail(task, '版本过低请升级');
          } else {
            this.runTaskFail(task, res.errMsg);
          }
        }
      });
    },
    // 分享消息到当前会话
    sendChatMessage(task) {
      let data = {
        msgtype: task.msgtype, //消息类型，必填
        enterChat: true //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
      };
      let msgtype = task.msgtype;
      // 不同消息类型处理成不同的数据结构
      let msg = {};
      if (msgtype == 'text') {
        msg = {
          content: task.content // 文本内容
        };
      } else if (msgtype == 'image' || msgtype == 'video' || msgtype == 'file') {
        msg = {
          mediaid: task.content // 图片/视频/文件的素材id
        };
      } else if (msgtype == 'news') {
        msg = {
          link: task.link, //H5消息页面url 必填
          title: task.title, //H5消息标题
          desc: task.desc, //H5消息摘要
          imgUrl: task.imgUrl //H5消息封面图片URL
        };
      } else if (msgtype == 'miniprogram') {
        msg = {
          appid: task.appId, //小程序的appid，企业已关联的任一个小程序
          title: task.title, //小程序消息的title
          imgUrl: task.imgUrl, //小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
          page: task.link //小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面，如'/pages/index/index.html"'
        };
      }
      data[msgtype] = msg;
      // 发送消息
      wx.invoke('sendChatMessage', data, res => {
        if (res.err_msg == 'sendChatMessage:ok') {
          this.runTaskSuccess(task);
        } else {
          this.runTaskFail(task, res.err_msg);
        }
      });
    },
    // 变更群成员
    updateEnterpriseChat(task) {
      wx.invoke(
        'updateEnterpriseChat',
        {
          chatId: task.chatId, //通过企业微信创建群聊接口返回的chatId
          userIdsToAdd: task.qwUserIdsToAdd //参与会话的企业成员列表，格式为userid1;userid2;...，用分号隔开。
        },
        res => {
          // 下面发送请求之前不能有alert，否则自动进入新群聊后，原页面不确认alert无法继续发送请求。
          if (res.err_msg == 'updateEnterpriseChat:ok') {
            this.runTaskSuccess(task);
          } else {
            this.runTaskFail(task, res.err_msg);
          }
        }
      );
    },
    removeStorage() {
      localStorage.clear();
    },
    intervalClear() {
      clearInterval(this.getNewTaskTimer);
      this.getNewTaskTimer = null;
    }
  }
};
</script>
<style scoped lang="scss">
.runTask {
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 0;
  padding: 0;
  .task-info {
    box-sizing: border-box;
    padding: 20px 20px 0 20px;
    .task-buttons {
      margin-top: 10px;
    }
  }
  .task-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 30px;
  }
  .task-logs {
    margin: 10px 10px 10px 20px;
    width: calc(100vw - 30px);
    box-sizing: border-box;
    flex: 1;
    overflow-y: auto;
    .task-log {
      width: 100%;
      display: flex;
      overflow: hidden;
      .log-time {
        margin-right: 5px;
      }
      .log-content {
        flex: 1;
        overflow: hidden;
        word-wrap: break-word;
        .log-type {
          margin-right: 3px;
        }
      }
    }
  }
}
</style>
